var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02183 4.199C1.71583 4.199 1.43683 4.127 1.18483 3.983C0.938832 3.839 0.743832 3.644 0.599832 3.398C0.461832 3.152 0.392832 2.873 0.392832 2.561C0.392832 2.261 0.461832 1.994 0.599832 1.76C0.737832 1.52 0.929832 1.331 1.17583 1.193C1.42183 1.049 1.70383 0.977 2.02183 0.977C2.32183 0.977 2.58883 1.049 2.82283 1.193C3.05683 1.331 3.24283 1.52 3.38083 1.76C3.52483 2 3.59983 2.267 3.60583 2.561C3.60583 2.873 3.53383 3.152 3.38983 3.398C3.25183 3.644 3.06283 3.839 2.82283 3.983C2.58883 4.127 2.32183 4.199 2.02183 4.199Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.96807c0c5eb78f4107b2ecb7203ca059.svg";
export { ForwardRef as ReactComponent };